import React, { Component } from "react";
import * as Hangul from "hangul-js";
import $ from "jquery";
import stl from "./ReferenceList.module.scss";

class ReferenceList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: this.props.data,
			start: this.props.start,
			list: this.props.data.slice(this.props.start, this.props.pageSize),
			searchList: [],
			searchText: "",
			lastPage: 0,
			curPage: 1, // 현재 페이지
			viewCnt: this.props.viewCnt,
			pageSize: this.props.pageSize,
			totalCnt: this.props.data.length,
			pageBtn: [],
			setHandleDown: 'basic',
			setDetailYear: '2025',
			setColumn:'토지 및 기후',
			setColumnComment:'토지 및 기후 설명 코멘트란입니다.',
			setColumnDetail: ['행정구역','토지지목별 현황','일기일수','기상개황','강수량'],
			setColumnDetailComment:['행정구역 설명입니다','토지지목별 현황 설명입니다','일기일수 설명입니다','기상개황 설명입니다','강수량 설명입니다'],
			allChecked: false, // 전체 선택 상태
			checkedItems: [], // 선택된 항목
		};
	}

	componentDidMount() {
		// console.log(this.props);
		this._init();
	}

	componentDidUpdate(prevProps, prevState) {
		const { lastPage, curPage, searchText } = this.state;
		const { pageSize, data } = this.props;
		if (curPage !== prevState.curPage) {
			const lastPage = this.state.searchList.length > 0 ? Math.ceil(this.state.searchList.length / pageSize) : Math.ceil(data.length / pageSize);
			this.setState({
				list: this.state.searchList.length > 0 ? this.state.searchList.slice((curPage - 1) * pageSize, curPage * pageSize) : data.slice((curPage - 1) * pageSize, curPage * pageSize),
				lastPage: lastPage,
				pageBtn: this.createPageBtn(lastPage, curPage),
			});
		}
		if (data.length !== prevProps.data.length) {
			const lastPage = Math.ceil(data.length / pageSize);
			this.setState({
				list: data.slice((curPage - 1) * pageSize, curPage * pageSize),
				lastPage: lastPage,
				pageBtn: this.createPageBtn(lastPage, curPage),
			});
		}
		if (searchText !== prevState.searchText) {
			if (searchText !== "") {
				const list = data.filter((item) => {
					return Hangul.rangeSearch(item.title, searchText).length > 0;
				});
				const lastPage = Math.ceil(list.length / pageSize);
				this.setState({
					list: list.slice(this.props.start, this.props.pageSize),
					searchList: list,
					pageBtn: this.createPageBtn(lastPage, curPage),
				});
			} else {
				this.setState({
					list: this.props.data.slice(this.props.start, this.props.pageSize),
					searchList: [],
					pageBtn: this.createPageBtn(lastPage, curPage),
				});
			}
		}
	}

	// 초기 설정
	_init = () => {
		const { data, pageSize } = this.props;
		const lastPage = Math.ceil(data.length / pageSize);
		const pageBtn = this.createPageBtn(lastPage, 1);

		this.setState({
			list: data.slice(0, pageSize),
			lastPage: lastPage,
			pageBtn: pageBtn,
		});
	};

	// Pagination 버튼 생성
	createPageBtn = (lastPage, curPage) => {
		const { viewCnt } = this.props;
		let pageBtn = [];

		const fPage = curPage % viewCnt === 0 ? curPage - viewCnt + 1 : curPage - (curPage % viewCnt) + 1;
		const lPage = fPage + viewCnt - 1 > lastPage ? lastPage : fPage + viewCnt - 1;

		for (let i = fPage; i <= lPage; i++) {
			if (i === curPage) {
				pageBtn.push(
					<div key={i} className={`${stl.pagingBtn} ${stl.number} ${stl.active}`} onClick={this.handlePaging}>
						{i}
					</div>
				);
			} else {
				pageBtn.push(
					<div key={i} className={`${stl.pagingBtn} ${stl.number}`} onClick={this.handlePaging}>
						{i}
					</div>
				);
			}
		}
		return pageBtn;
	};

	// 페이지 버튼 클릭 시
	handlePaging = (e) => {
		this.setState({
			curPage: parseInt(e.target.innerText),
		});
	};

	// 다음 페이지
	handleNextPage = () => {
		this.setState({
			curPage: this.state.curPage === this.state.lastPage ? this.state.lastPage : this.state.curPage + 1,
		});
	};

	// 이전 페이지
	handlePrevPage = () => {
		this.setState({
			curPage: this.state.curPage - 1 === 0 ? 1 : this.state.curPage - 1,
		});
	};

	// 첫페이지
	handleFirstPage = () => {
		this.setState({
			curPage: 1,
		});
	};

	// 마지막 페이지
	handleLastPage = () => {
		this.setState({
			curPage: this.state.lastPage,
		});
	};

	// 검색어 입력
	changeInput = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
		});
	};

	// 상세보기 이동
	toDetail = (e) => {
		let id = "";
		if (e.target.nodeName === "svg") {
			id = e.target.parentElement.parentElement.children[1].innerText;
		} else {
			id = e.target.parentElement.children[1].innerText;
		}
		window.location.href = "/reference/" + id;
	};

	basicDown = (year) => {
		const link = document.createElement("a");
		document.body.appendChild(link);
		link.setAttribute("download", year+" 통계연보.zip");
		link.href = "/sis/reference/"+year+" 통계연보.zip";
		link.click();
		document.body.removeChild(link);
	};

	handleOptionClick = (option) => {
		this.setState({
			setDetailYear:"2025",
			setColumn:'토지 및 기후',
			allChecked: false, // 전체 선택 상태
			checkedItems: [], // 선택된 항목
			setColumnDetail: ['행정구역','토지지목별 현황','일기일수','기상개황','강수량'],
			setColumnDetailComment: ['행정구역 설명입니다','토지지목별 현황 설명입니다','일기일수 설명입니다','기상개황 설명입니다','강수량 설명입니다']
		});
		$("input[name=allCheckbox]").prop("checked",false);

		if(option === 'basic') {
			this.setState({
				setHandleDown: 'basic',
			});
		}else if(option === 'detail'){
			this.setState({
				setHandleDown: 'detail',
			});
		}
	};

	selectYear = (Year) => {
		this.setState({
			allChecked: false,
			checkedItems: [],
			setColumn:'토지 및 기후',
			setColumnDetail: ['행정구역','토지지목별 현황','일기일수','기상개황','강수량'],
			setColumnDetailComment: ['행정구역 설명입니다','토지지목별 현황 설명입니다','일기일수 설명입니다','기상개황 설명입니다','강수량 설명입니다']
		});
		$("input[name=allCheckbox]").prop("checked",false);

		if(Year === '2025') {
			this.setState({
				setDetailYear: '2025',
			});
		}else if(Year === '2024') {
			this.setState({
				setDetailYear: '2024',
			});
		}else if(Year === '2023'){
			this.setState({
				setDetailYear: '2023',
			});
		}else if(Year === '2022'){
			this.setState({
				setDetailYear: '2022',
			});
		}else if(Year === '2021'){
			this.setState({
				setDetailYear: '2021',
			});
		}else if(Year == '2020'){
			this.setState({
				setDetailYear: '2020',
			});
		}else if(Year === '2019'){
			this.setState({
				setDetailYear: '2019',
			});
		}else if(Year === '2018'){
			this.setState({
				setDetailYear: '2018',
			});
		}else if(Year === '2017'){
			this.setState({
				setDetailYear: '2017',
			});
		}else if(Year === '2016'){
			this.setState({
				setDetailYear: '2016',
			});
		}
	};

	columnClick = (column) => {
		this.setState({
			allChecked: false, // 전체 선택 상태
			checkedItems: [], // 선택된 항목
		});
		$("input[name=allCheckbox]").prop("checked",false);

		if(column === '토지 및 기후') {
			this.setState({
				setColumn: '토지 및 기후',
				setColumnComment: '토지 및 기후 설명 코멘트란입니다',
				setColumnDetail: ['행정구역','토지지목별 현황','일기일수','기상개황','강수량'],
				setColumnDetailComment: ['행정구역 설명입니다','토지지목별 현황 설명입니다','일기일수 설명입니다','기상개황 설명입니다','강수량 설명입니다']
			});
		}else if(column === '인구') {
			this.setState({
				setColumn: '인구',
				setColumnComment: '인구 설명 코멘트란입니다',
				setColumnDetail: ['인구추이','구별 세대 및 등록인구','동별 세대 및 등록인구','연령별 및 성별인구','인구동태','인구동태(구별)','인구이동','인구이동(구별)','주민등록전입지별 인구이동','주민등록전출지별 인구이동','외국인 국적별 등록현황','외국인과의 혼인','사망원인별 사망','사망원인별 사망(구별)','혼인율','이혼율','여성가구주 현황','다문화 가구 및 가구원','가구원수별 가구(일반가구)'],
				setColumnDetailComment: [
					'인구추이 설명입니다',
					'구별 세대 및 등록인구 설명입니다',
					'동별 세대 및 등록인구 설명입니다',
					'연령별 및 성별인구 설명입니다',
					'인구동태','인구동태(구별) 설명입니다',
					'인구이동 설명입니다',
					'인구이동(구별) 설명입니다',
					'주민등록전입지별 인구이동 설명입니다',
					'주민등록전출지별 인구이동 설명입니다',
					'외국인 국적별 등록현황 설명입니다',
					'외국인과의 혼인 설명입니다',
					'사망원인별 사망 설명입니다',
					'사망원인별 사망(구별) 설명입니다',
					'혼인율 설명입니다',
					'이혼율 설명입니다',
					'여성가구주 현황 설명입니다',
					'다문화 가구 및 가구원 설명입니다',
					'가구원수별 가구(일반가구) 설명입니다']
			});
		}else if(column === '노동') {
			this.setState({
				setColumn: '노동',
				setColumnComment: '노동 설명 코멘트란입니다',
				setColumnDetail: ['경제활동인구총괄','연령별취업자','교육정도별취업자','산업별취업자','직업별취업자'],
				setColumnDetailComment: [
					'경제활동인구총괄 설명입니다',
					'연령별취업자 설명입니다',
					'교육정도별취업자 설명입니다',
					'산업별취업자 설명입니다',
					'직업별취업자 설명입니다',
					]
			});
		}else if(column === '사업체') {
			this.setState({
				setColumn: '사업체',
				setColumnComment: '사업체 설명 코멘트란입니다',
				setColumnDetail: ['사업체 총괄','종사자규모별사업체수및종사자수','산업별 사업체수및종사자수'],
				setColumnDetailComment: [
					'사업체 총괄 설명입니다',
					'종사자규모별사업체수및종사자수 설명입니다',
					'산업별 사업체수및종사자수 설명입니다',
				]
			});
		}else if(column === '농림수산업') {
			this.setState({
				setColumn: '농림수산업',
				setColumnComment: '농림수산업 설명 코멘트란입니다',
				setColumnDetail: ['농가및농가인구','연령별농가인구','경지면적','경지규모별농가','식량작물생산(정곡)','미곡','맥류','잡곡','두류','서류','채소류 생산량','특용작물 생산량','과실류 생산량','농업기계 보유현황','가축사육','가축전염병발생','임산물 생산량','임목벌채허가','조림','불법산림훼손 피해현황','친환경 농축산물 출하현황','화훼 재배현황'],
				setColumnDetailComment: [
					'농가및농가인구 설명입니다',
					'연령별농가인구 설명입니다',
					'경지면적 설명입니다',
					'경지규모별농가 설명입니다',
					'식량작물생산(정곡) 설명입니다',
					'미곡 설명입니다','맥류 설명입니다',
					'잡곡 설명입니다','두류 설명입니다',
					'서류 설명입니다','채소류 생산량 설명입니다',
					'특용작물 생산량 설명입니다',
					'과실류 생산량 설명입니다',
					'농업기계 보유현황 설명입니다',
					'가축사육 설명입니다',
					'가축전염병발생 설명입니다',
					'임산물 생산량 설명입니다',
					'임목벌채허가 설명입니다',
					'조림 설명입니다',
					'불법산림훼손 피해현황 설명입니다',
					'친환경 농축산물 출하현황 설명입니다',
					'화훼 재배현황 설명입니다']
			});

		}else if(column == '광업제조업 및 에너지') {
			this.setState({
				setColumn: '광업제조업 및 에너지',
				setColumnComment: '광업제조업 및 에너지 설명 코멘트란입니다',
				setColumnDetail: ['광업및제조업(신분류)','사업체규모별 광업 및 제조업(10인이상)','제조업 중분류별 사업체및종사자수','산업및농공단지','석유류소비량','에너지 관리대상 현황','신재생에너지 지역별 생산량(고유단위)','1인당 최종에너지 소비량'],
				setColumnDetailComment: ['광업및제조업(신분류) 설명입니다','사업체규모별 광업 및 제조업(10인이상) 설명입니다','제조업 중분류별 사업체및종사자수 설명입니다','산업및농공단지 설명입니다','석유류소비량 설명입니다','에너지 관리대상 현황 설명입니다','신재생에너지 지역별 생산량(고유단위) 설명입니다','1인당 최종에너지 소비량 설명입니다']
			});
		}else if(column === '전기·가스·수도') {
			this.setState({
				setColumn: '전기·가스·수도',
				setColumnComment: '전기·가스·수도 설명 코멘트란입니다',
				setColumnDetail: ['발전현황','용도별 전력사용량','제조업종별 전력사용량','가스공급량','도시가스보급률','상수도 보급현황','상수도관','정수장별 상수도시설용량 및 생산실적','급수사용량','급수 사용료 부과','하수도 보급률','하수도사용료부과','하수관거'],
				setColumnDetailComment: [
					'발전현황 설명입니다',
					'용도별 전력사용량 설명입니다',
					'제조업종별 전력사용량 설명입니다',
					'가스공급량 설명입니다',
					'도시가스보급률 설명입니다',
					'상수도 보급현황 설명입니다',
					'상수도관 설명입니다',
					'정수장별 상수도시설용량 및 생산실적 설명입니다',
					'급수사용량 설명입니다',
					'급수 사용료 부과 설명입니다',
					'하수도 보급률 설명입니다',
					'하수도사용료부과 설명입니다',
					'하수관거 설명입니다',
				]
			});
		}else if(column === '유통·금융·보험및기타서비스') {
			this.setState({
				setColumn: '유통·금융·보험및기타서비스',
				setColumnComment: '유통·금융·보험및기타서비스 설명 코멘트란입니다',
				setColumnDetail: ['가계대출규모','소비자물가지수','농수산물도매시장별유통량','수출입통관실적','수출실적','수입실적'],
				setColumnDetailComment: ['가계대출규모 설명입니다','소비자물가지수 설명입니다','농수산물도매시장별유통량 설명입니다','수출입통관실적 설명입니다','수출실적 설명입니다','수입실적 설명입니다']
			});
		}else if(column === '주택·건설') {
			this.setState({
				setColumn: '주택·건설',
				setColumnComment: '주택·건설 설명 코멘트란입니다',
				setColumnDetail: ['주택현황및보급률','주택소유현황','건축연도별 주택','연면적별 주택','건축허가','구별 건축허가','주택가격지수','토지거래허가','지가변동률','토지거래현황',
					'용도지역','용도지구','공원','댐현황','도로','폭원별 도로현황','교량','건설장비'],
				setColumnDetailComment: ['주택현황및보급률 설명입니다'
					,'주택소유현황 설명입니다'
					,'건축연도별 주택 설명입니다'
					,'연면적별 주택 설명입니다'
					,'건축허가 설명입니다.'
					,'구별 설명입니다'
					,'주택가격지수 설명입니다'
					,'토지거래허가 설명입니다'
					,'지가변동률 설명입니다'
					,'토지거래현황 설명입니다'
					,'용도지역 설명입니다'
					,'용도지구 설명입니다'
					,'공원 설명입니다'
					,'댐현황 설명입니다'
					,'도로 설명입니다'
					,'폭원별 도로현황 설명입니다'
					,'교량 설명입니다'
					,'건설장비 설명입니다']
			});
		}else if(column === '교통관광') {
			this.setState({
				setColumn: '교통관광',
				setColumnComment: '교통관광 설명 코멘트란입니다',
				setColumnDetail: ['자동차등록','구별 자동차등록','구별 자동차연료 종류별 등록','영업용자동차업종별수송','철도수송','관광사업체 등록','주요관광지 방문객수'],
				setColumnDetailComment: ['자동차등록 설명입니다',
					'구별 자동차등록 설명입니다',
					'구별 자동차연료 종류별 설명입니다',
					'영업용자동차업종별수송 설명입니다',
					'철도수송 설명입니다',
					'관광사업체 설명입니다',
					'주요관광지 방문객수 설명입니다']
			});
		}else if(column === '보건 및 사회보장') {
			this.setState({
				setColumn: '보건 및 사회보장',
				setColumnComment: '보건 및 사회보장 설명 코멘트란입니다',
				setColumnDetail: ['의료기관','의료기관종사의료인력','보건소 인력','보건지소 및 보건진료소,건강생활지원센터 인력','의약품등제조업소및판매업소'
				,'식품위생관계업소','공중위생관계업소','예방접종','주요법정감염병 발생및사망','결핵환자현황'
				,'보건소 구강보건사업 실적','모자보건사업실적','건강보험 적용인구','건강보험급여','건강보험대상자 진료실적'
				,'국민연금가입자','국민연금급여지급현황','노인여가복지시설','노인주거복지시설','노인의료복지시설'
				,'재가노인복지시설','국민기초생활보장수급자','기초연금 수급자 수','여성복지시설','여성폭력상담'
				,'아동복지시설','장애인거주시설 수','장애인등록현황','보호대상아동 발생 및 조치현황','헌혈사업실적'
				,'어린이집','사회복지자원봉사자'],
				setColumnDetailComment: ['의료기관 설명입니다','의료기관종사의료인력 설명입니다','보건소 인력 설명입니다','보건지소 및 보건진료소 설명입니다,건강생활지원센터 인력 설명입니다','의약품등제조업소및판매업소 설명입니다'
					,'식품위생관계업소 설명입니다','공중위생관계업소 설명입니다','예방접종 설명입니다','주요법정감염병 발생및사망 설명입니다','결핵환자현황 설명입니다'
					,'보건소 구강보건사업 실적 설명입니다','모자보건사업실적 설명입니다','건강보험 적용인구 설명입니다','건강보험급여 설명입니다','건강보험대상자 진료실적 설명입니다'
					,'국민연금가입자 설명입니다','국민연금급여지금현황 설명입니다','노인여가복지시설 설명입니다','노인주거복지시설 설명입니다','노인의료복지시설 설명입니다'
					,'재가노인복지시설 설명입니다','국민기초생활보장수급자 설명입니다','기초연금 수급자 수 설명입니다','여성복지시설 설명입니다','여성폭력상담 설명입니다'
					,'아동복지시설 설명입니다','장애인거주시설 수 설명입니다','장애인등록현황 설명입니다','보호대상아동 발생 및 조치현황 설명입니다','헌혈사업실적 설명입니다'
					,'어린이집 설명입니다','사회복지자원봉사자 설명입니다']
			});
		}else if(column === '환경') {
			this.setState({
				setColumn: '환경',
				setColumnComment: '환경 설명 코멘트란입니다',
				setColumnDetail: ['환경오염물질배출사업장','환경오염배출사업장 단속 및 행정조치','배출부과금 부과 및 징수현황','대기오염','소음도','쓰레기수거','생활폐기물매립지','폐기물 재활용률','공공하수처리시설','시설녹지현황'],
				setColumnDetailComment: ['환경오염물질배출사업장 설명입니다','환경오염배출사업장 단속 및 행정조치 설명입니다','배출부과금 부과 및 징수현황 설명입니다','대기오염 설명입니다','소음도 설명입니다','쓰레기수거 설명입니다',
					'생활폐기물매립지 설명입니다','폐기물 재활용률 설명입니다','공공하수처리시설 설명입니다','시설녹지현황 설명입니다']
			});
		}else if(column === '교육 및 문화') {
			this.setState({
				setColumn: '교육 및 문화',
				setColumnComment: '교육 및 문화 설명 코멘트란입니다',
				setColumnDetail: ['학교총개황','유치원','초등학교','가-중학교(국·공립)','나-중학교(사립)',
					'가-일반고등학교(국·공립)','나-일반고등학교(사립)','특수목적고등학교(국·공립)','가-특성화고등학교(국·공립)','나-특성화고등학교(사립)',
					'자율고등학교(국·공립)','전문대학','교육대학교','대학교','대학원',
					'기타학교','적령아동취학','사설학원','공공도서관','문화재',
					'체육시설-(가)공공체육시설','체육시설-(나)신고등록체육시설','청소년 수련시설','언론매체'],
				setColumnDetailComment: ['학교총개황 설명입니다','유치원 설명입니다','초등학교 설명입니다','가-중학교(국·공립) 설명입니다','나-중학교(사립) 설명입니다',
					'가-일반고등학교(국·공립) 설명입니다','나-일반고등학교(사립) 설명입니다','특수목적고등학교(국·공립) 설명입니다','가-특성화고등학교(국·공립) 설명입니다','나-특성화고등학교(사립) 설명입니다',
					'자율고등학교(국·공립) 설명입니다','전문대학 설명입니다','교육대학교 설명입니다','대학교 설명입니다','대학원 설명입니다',
					'기타학교 설명입니다','적령아동취학 설명입니다','사설학원 설명입니다','공공도서관 설명입니다','문화재 설명입니다',
					'체육시설-(가)공공체육시설 설명입니다','체육시설-(나)신고등록체육시설 설명입니다','청소년 수련시설 설명입니다','언론매체 설명입니다']
			});
		}else if(column === '재정') {
			this.setState({
				setColumn: '재정',
				setColumnComment: '재정 설명 코멘트란입니다',
				setColumnDetail: ['국세징수','지방세부담','지방세징수','지방재정자립지표'],
				setColumnDetailComment: ['국세징수 설명입니다','지방세부담 설명입니다','지방세징수 설명입니다','지방재정자립지표 설명입니다']
			});
		}else if(column === '소득 및 지출') {
			this.setState({
				setColumn: '소득 및 지출',
				setColumnComment: '소득 및 지출 설명 코멘트란입니다',
				setColumnDetail: ['지역소득','제도부문별 지역소득','경제활동별 시내 총생산(당해년가격)','경제활동별 시내 총생산(기준년가격)','시내 총생산에 대한 지출(당해년가격)','시내 총생산에 대한 지출(기준년가격)'],
				setColumnDetailComment: ['지역소득 설명입니다','제도부문별 지역소득 설명입니다','경제활동별 시내 총생산(당해년가격) 설명입니다'
					,'경제활동별 시내 총생산(기준년가격) 설명입니다','시내 총생산에 대한 지출(당해년가격) 설명입니다','시내 총생산에 대한 지출(기준년가격) 설명입니다']
			});
		}else if(column === '공공행정 및 사법') {
			this.setState({
				setColumn: '공공행정 및 사법',
				setColumnComment: '공공행정 및 사법 설명 코멘트란입니다',
				setColumnDetail: ['공무원총괄','시본청공무원','시의회사무처 직속기관 사업소','자치구공무원','동공무원','소방공무원','경찰공무원','퇴직사유별공무원'
					,'화재발생','발화요인별 화재발생','장소별화재발생','산불발생 현황','소방장비','119구급실적','119구조활동실적','재난사고 발생 및 피해현황'
					,'자연재해 발생 및 피해현황','소방대상물현황','위험물제조소설치현황','교통사고건수(자동차)','자동차단속및처리','운전면허소지자'],
				setColumnDetailComment: ['공무원총괄 설명입니다','시본청공무원 설명입니다','시의회사무처 직속기관 사업소 설명입니다','자치구공무원 설명입니다','동공무원 설명입니다','소방공무원 설명입니다','경찰공무원 설명입니다','퇴직사유별공무원 설명입니다'
					,'화재발생 설명입니다','발화요인별 화재발생 설명입니다','장소별화재발생 설명입니다','산불발생 현황 설명입니다','소방장비 설명입니다','119구급실적 설명입니다','119구조활동실적 설명입니다','재난사고 발생 및 피해현황 설명입니다'
					,'자연재해 발생 및 피해현황 설명입니다','소방대상물현황 설명입니다','위험물제조소설치현황 설명입니다','교통사고건수(자동차) 설명입니다','자동차단속및처리 설명입니다','운전면허소지자 설명입니다']
			});
		}
	}

	handleAllCheckboxChange = (event) => {
		const { checked } = event.target;
		this.setState({
			allChecked: checked,
			checkedItems: checked ? this.state.setColumnDetail.map((item) => item) : [],
		});
	};

	handleCheckboxChange = (event) => {
		const { value } = event.target;
		const { checkedItems } = this.state;

		if (event.target.checked) {
			checkedItems.push(value);
		} else {
			checkedItems.splice(checkedItems.indexOf(value), 1);
		}

		this.setState({
			checkedItems,
			allChecked: checkedItems.length === this.state.setColumnDetail.length,
		});
		// console.log(this.state.checkedItems)
	};

	/*selectDown = (event) => {
		const fileName = this.state.setDetailYear + '_' + this.state.setColumn + '_' + event + '.xlsx';
		const fileUrl = "/sis/reference/" + fileName;

		// 파일 존재 여부 확인
		fetch(fileUrl, { method: 'HEAD' })
			.then(response => {
				if (response.ok) {
					// 파일이 존재하면 다운로드
					const link = document.createElement("a");
					document.body.appendChild(link);
					link.setAttribute("download", fileName);
					link.href = fileUrl;
					link.click();
					document.body.removeChild(link);
				} else {
					// 파일이 존재하지 않을 때
					alert("해당 통계연보는 존재하지 않는 파일입니다.");
				}
			})
			.catch(error => {
				console.error("파일 확인 중 오류 발생:", error);
				alert("파일 확인 중 오류가 발생했습니다.");
			});
	}*/

	selectDown = (event) => {
		const fileName = this.state.setDetailYear + '_' + this.state.setColumn + '_' + event + '.xlsx';
		const fileUrl = "/sis/reference/" + fileName;
		fetch(fileUrl, { method: 'HEAD' })
			.then(response => {
				if (response.ok) {
					window.location.href = fileUrl;
				} else {
					throw new Error("파일 없음");
				}
			})
			.catch(error => {
				console.error("다운로드 오류:", error);
				alert("해당 통계연보는 존재하지 않는 파일입니다.");
			});

		// fetch(fileUrl,{ method: 'HEAD' })
		// 	.then(response => {
		// 		if (response.ok){
		// 			return response.blob();
		// 		}else{
		// 			throw new Error("파일 없음");
		// 		}
		// 	})
		// 	.then(blob => {
		// 		const url = window.URL.createObjectURL(blob);
		// 		const a = document.createElement("a");
		// 		a.href = url;
		// 		a.download = fileName;
		// 		document.body.appendChild(a);
		// 		a.click();
		// 		a.remove();
		// 		window.URL.revokeObjectURL(url);
		// 	})
		// 	.catch(error => {
		// 		console.error("다운로드 오류:", error);
		// 		alert("해당 통계연보는 존재하지 않는 파일입니다.");
		// 	});
	};

	checkboxSelectDown = (event) => {
		if (event[0] === undefined) {
			alert('선택 목록이 없습니다.');
			return;
		}
		let stopDownload = false; // 다운로드 중단 여부
		event.forEach((item, index) => {
			setTimeout(() => {
				if (stopDownload) return;
				const fileName = this.state.setDetailYear + '_' + this.state.setColumn + '_' + item + '.xlsx';
				const fileUrl = "/sis/reference/" + fileName;
				// 파일 존재 여부 확인
				fetch(fileUrl, { method: 'HEAD' })
					.then(response => {
						if (response.ok) {
							const link = document.createElement("a");
							document.body.appendChild(link);
							link.setAttribute("download", fileName);
							link.href = fileUrl;
							link.click();
							document.body.removeChild(link);
						} else {
							const userConfirm = window.confirm(`"${fileName}" 파일이 존재하지 않습니다.\n계속 진행하시겠습니까?`);
							if (!userConfirm) {
								stopDownload = true;
							} else {
								stopDownload = false;
							}
						}
					})
					.catch(error => {
						alert("파일 확인 중 오류가 발생했습니다.");
						stopDownload = true; // 오류 발생 시 중단
					});
			}, index * 500); // 순차적 요청을 위한 딜레이
		});
	}

	render() {
		return (
			<div id={stl.listWrapper}>
				<div id={stl.downArea}>
					<div id={stl.basicDown} style={{backgroundColor: this.state.setHandleDown === 'basic' ? '#000b93' : 'white' , color:this.state.setHandleDown === 'basic' ? 'white' : '#000b93'}}
						 onClick={() =>{this.handleOptionClick('basic')}}>전체 데이터 다운로드</div>
					<div id={stl.detailDown} style={{backgroundColor: this.state.setHandleDown === 'detail' ? '#000b93' : 'white' , color:this.state.setHandleDown === 'detail' ? 'white' : '#000b93'}}
						 onClick={() =>{this.handleOptionClick('detail')}}>년도별 상세 다운로드</div>
				</div>

				<div id={stl.basicDownOption} style={{display: this.state.setHandleDown === 'basic' ? 'block' : 'none'}}>
					<div id={stl.basicDownload} >
						<p id={stl.basicTitleText}>2025년 광주 통계연보
							<div id={stl.basicText}>2025년까지의 전남광주통합특별시(광주) 전체 통계연보를 제공 받을 수 있습니다.</div>
						</p>
						<p id={stl.basicDownloadButton} onClick={() =>{this.basicDown('2025')}}>다운로드</p>
					</div>
					<div id={stl.basicDownload} >
						<p id={stl.basicTitleText}>2024년 광주 통계연보
							<div id={stl.basicText}>2024년까지의 전남광주통합특별시(광주) 전체 통계연보를 제공 받을 수 있습니다.</div>
						</p>
						<p id={stl.basicDownloadButton} onClick={() =>{this.basicDown('2024')}}>다운로드</p>
					</div>
					<div id={stl.basicDownload} >
						<p id={stl.basicTitleText}>2023년 광주 통계연보
							<div id={stl.basicText}>2023년까지의 전남광주통합특별시(광주) 전체 통계연보를 제공 받을 수 있습니다.</div>
						</p>
						<p id={stl.basicDownloadButton} onClick={() =>{this.basicDown('2023')}}>다운로드</p>
					</div>
					<div id={stl.basicDownload} >
						<p id={stl.basicTitleText}>2022년 광주 통계연보
							<div id={stl.basicText}>2022년까지의 전남광주통합특별시(광주) 전체 통계연보를 제공 받을 수 있습니다.</div>
						</p>
						<p id={stl.basicDownloadButton} onClick={() =>{this.basicDown('2022')}}>다운로드</p>
					</div>
				</div>

				<div id={stl.detailDownOption} style={{display: this.state.setHandleDown === 'detail' ? 'block' : 'none'}}>
					<div id={stl.detailYearOption}>
						<p id={stl.yearText}>선택년도</p>
						<div id={stl.years}>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2025' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2025' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2025')}}>2025년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2024' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2024' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2024')}}>2024년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2023' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2023' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2023')}}>2023년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2022' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2022' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2022')}}>2022년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2021' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2021' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2021')}}>2021년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2020' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2020' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2020')}}>2020년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2019' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2019' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2019')}}>2019년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2018' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2018' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2018')}}>2018년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2017' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2017' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2017')}}>2017년</div>
							<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2016' ? '#0921b5' : '#eff5ff', color:this.state.setDetailYear === '2016' ? 'white' : '#000b93'}}
								 onClick={() =>{this.selectYear('2016')}}>2016년</div>
						</div>
						{/*<div id={stl.years}>*/}
						{/*	<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2017' ? 'yellow' : 'white' , marginTop: '20px'}} onClick={() =>{this.selectYear('2017')}}>2017년</div>*/}
						{/*	<div id={stl.detailYear} style={{backgroundColor: this.state.setDetailYear === '2016' ? 'yellow' : 'white' , marginTop: '20px'}} onClick={() =>{this.selectYear('2016')}}>2016년</div>*/}
						{/*</div>*/}
					</div>
					<div id={stl.statisticalList}>
						<div id={stl.statisticalText}>년도별 상세 다운로드 - <span style={{color:'#0921b5'}}>{this.state.setDetailYear}년</span></div>
						<div id={stl.statisticalGroup}>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '토지 및 기후' ? '#0921b5' : 'white', color:this.state.setColumn === '토지 및 기후' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('토지 및 기후')}}>토지 및 기후</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '인구' ? '#0921b5' : 'white', color:this.state.setColumn === '인구' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('인구')}}>인구</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '노동' ? '#0921b5' : 'white', color:this.state.setColumn === '노동' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('노동')}}>노동</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '사업체' ? '#0921b5' : 'white', color:this.state.setColumn === '사업체' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('사업체')}}>사업체</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '농림수산업' ? '#0921b5' : 'white', color:this.state.setColumn === '농림수산업' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('농림수산업')}}>농림수산업</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '광업제조업 및 에너지' ? '#0921b5' : 'white', color:this.state.setColumn === '광업제조업 및 에너지' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('광업제조업 및 에너지')}}>광업제조업 및 에너지</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '전기·가스·수도' ? '#0921b5' : 'white', color:this.state.setColumn === '전기·가스·수도' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('전기·가스·수도')}}>전기·가스·수도</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '유통·금융·보험및기타서비스' ? '#0921b5' : 'white', color:this.state.setColumn === '유통·금융·보험및기타서비스' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('유통·금융·보험및기타서비스')}}>유통·금융·보험및기타서비스</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '주택·건설' ? '#0921b5' : 'white', color:this.state.setColumn === '주택·건설' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('주택·건설')}}>주택·건설</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '교통관광' ? '#0921b5' : 'white', color:this.state.setColumn === '교통관광' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('교통관광')}}>교통관광</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '보건 및 사회보장' ? '#0921b5' : 'white', color:this.state.setColumn === '보건 및 사회보장' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('보건 및 사회보장')}}>보건 및 사회보장</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '환경' ? '#0921b5' : 'white', color:this.state.setColumn === '환경' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('환경')}}>환경</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '교육 및 문화' ? '#0921b5' : 'white', color:this.state.setColumn === '교육 및 문화' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('교육 및 문화')}}>교육 및 문화</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '재정' ? '#0921b5' : 'white', color:this.state.setColumn === '재정' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('재정')}}>재정</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '소득 및 지출' ? '#0921b5' : 'white', color:this.state.setColumn === '소득 및 지출' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('소득 및 지출')}}>소득 및 지출</div>
							<div id={stl.groupColumn} style={{backgroundColor: this.state.setColumn === '공공행정 및 사법' ? '#0921b5' : 'white', color:this.state.setColumn === '공공행정 및 사법' ? 'white' : ''}}
								 onClick={() =>{this.columnClick('공공행정 및 사법')}}>공공행정 및 사법</div>
						</div>
						{/*<div id={stl.statisticalDescription}>{this.state.setColumnComment}</div>*/}
					</div>
					<div id={stl.detailDownload}>
						<div id={stl.listBtn}>
							<div id={stl.resultText}>{this.state.setColumn} 검색결과: &nbsp;<span style={{color:'#0921b5'}}>{this.state.setColumnDetail.length}건</span></div>
							<div>								
							<div id={stl.allCheckboxDiv}>
								<input type="checkbox" name="allCheckbox" id = "allCheckbox" class={stl.allCheckbox} onChange={this.handleAllCheckboxChange}></input>
								<label htmlFor="allCheckbox" id={stl.allCheckboxText}>전체선택</label>
							</div>
							<div id={stl.listButton } onClick={() =>{this.checkboxSelectDown(this.state.checkedItems)}}>선택 다운로드</div>
							</div>
						</div>
						<table id={stl.detailDownTable}>
							<caption>통계연보 세부항목 검색결과</caption>
							<thead id={stl.detailDownTableHead}>
								<tr id={stl.statisticalTr}>
									<th id={stl.statisticalTitle} >목록</th>
									<th id={stl.statisticalCommentTitle}>설명</th>
									<th id={stl.statisticalDownload}>다운로드</th>
									<th id={stl.statisticalChoice}>선택</th>
								</tr>
							</thead>
							<tbody>
								{this.state.setColumnDetail.map((item,idx)=>{
									return (
										<tr key={idx}>
											<td id={stl.statisticalTitle}>{item}</td>
											<td id={stl.statisticalComment}>{this.state.setColumnDetailComment[idx]}</td>
											<td id={stl.statisticalDownload}>
												<p id={stl.statisticalDownloadButton} onClick={() =>{this.selectDown(item)}}>다운로드</p>
											</td>
											<td id={stl.statisticalCheckboxChoice}>
												<label>
													<input
														id={stl.statisticalChoiceCheckbox}
														type="checkbox"
														name="downChoice"
														value={item}
														checked={this.state.checkedItems.includes(item)}
														onChange={this.handleCheckboxChange}
													/>
												</label>
											</td>
										</tr>
									);
									})
								}
							</tbody>
						</table>
					</div>
				</div>

			</div>
		);
	}
}

export default ReferenceList;
